/**
 * Canonical Finnish maakunnat (regions). Same set the backend AI search
 * prompt uses (`public_handler.go:572`). Ahvenanmaa is omitted — the
 * metsadata scrapers do not cover it.
 *
 * Each region has an approximate centroid that we use as the default map
 * pan/zoom target until per-municipality coordinates (smt_kunta_coords)
 * are wired in M6.
 */
export interface RegionInfo {
  /** Finnish canonical name as stored in the database. */
  name: string;
  /** Approximate centroid (lat, lon) — Leaflet `[lat, lon]` order. */
  center: [number, number];
}

export const REGIONS: RegionInfo[] = [
  { name: 'Uusimaa', center: [60.35, 24.95] },
  { name: 'Varsinais-Suomi', center: [60.45, 22.27] },
  { name: 'Satakunta', center: [61.55, 22.05] },
  { name: 'Kanta-Häme', center: [60.95, 24.45] },
  { name: 'Pirkanmaa', center: [61.66, 23.85] },
  { name: 'Päijät-Häme', center: [61.05, 25.65] },
  { name: 'Kymenlaakso', center: [60.7, 26.95] },
  { name: 'Etelä-Karjala', center: [61.07, 28.2] },
  { name: 'Etelä-Savo', center: [61.69, 27.27] },
  { name: 'Pohjois-Savo', center: [63.1, 27.65] },
  { name: 'Pohjois-Karjala', center: [62.6, 29.75] },
  { name: 'Keski-Suomi', center: [62.55, 25.7] },
  { name: 'Etelä-Pohjanmaa', center: [62.95, 22.95] },
  { name: 'Pohjanmaa', center: [63.1, 21.6] },
  { name: 'Keski-Pohjanmaa', center: [63.85, 23.85] },
  { name: 'Pohjois-Pohjanmaa', center: [65.0, 26.0] },
  { name: 'Kainuu', center: [64.25, 28.6] },
  { name: 'Lappi', center: [67.5, 26.5] },
];

export function regionCenter(name: string | undefined | null): [number, number] {
  if (!name) return [64.0, 26.0]; // Finland centroid fallback
  const r = REGIONS.find((x) => x.name === name);
  return r ? r.center : [64.0, 26.0];
}
